export default __webpack_public_path__ + "static/media/e.13f45242.jpeg";